<template>
  <div id="studentCenter">
    <div class="dialog_divV2">
        <iframe class="iframe_url" name="iframename" :src="this.url" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: "OpenMobile",
  props: {
    UrlOpenFlag: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "",
    },

    dialogTitle: {
      type: String,
      default: "湖北专升本网",
    },
    width: {
      type: String,
      default: "450px",
    },
    data() {
      return {
      };
    },
    watch: {
     
    },
    methods: {
      QualityDialogClose() {
        this.$emit("update:UrlOpenFlag", false);
      },
    },
  },
};
</script>
<style scoped>
.dialog_divV2{
  height: 600px;
}
.iframe_url {
  width: 100%;
  height: 600px;
}
.read-pop-con .swiper-container {
  width: 95%;
}
.student_dialog .el-dialog__body {
  padding: 0;
}
</style>